import { render, staticRenderFns } from "./AboutNew.vue?vue&type=template&id=3d14dd21&scoped=true&"
import script from "./AboutNew.vue?vue&type=script&lang=js&"
export * from "./AboutNew.vue?vue&type=script&lang=js&"
import style0 from "./AboutNew.vue?vue&type=style&index=0&id=3d14dd21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d14dd21",
  null
  
)

export default component.exports